__turbopack_context__.v({
  "cta-link": "CXV1jq_cta-link",
  "divider": "CXV1jq_divider",
  "header": "CXV1jq_header",
  "single-article-container": "CXV1jq_single-article-container",
  "title": "CXV1jq_title",
  "title-link": "CXV1jq_title-link",
  "title-link-container": "CXV1jq_title-link-container",
});
